import { render, staticRenderFns } from "./vacation-requests.vue?vue&type=template&id=f5aa9862"
import script from "./vacation-requests.vue?vue&type=script&lang=js"
export * from "./vacation-requests.vue?vue&type=script&lang=js"
import style0 from "./vacation-requests.vue?vue&type=style&index=0&id=f5aa9862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports